import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TwoDimensionalAiAssessmentViewModelRead } from '../../_models/generatedModels';
import { Enums } from '../../_models/generatedEnums';

@Component({
  selector: 'general-details-popup',
  templateUrl: 'general-details-popup.component.html',
  styleUrls: ['public-two-dimensional-ai-result-details.component.scss']
})
export class GeneralDetailsPopupComponent implements OnInit {
  initialized = false;
  categoryScoreEnum = Enums.CategoryScoreEnum;
  footStrikePatternEnum = Enums.FootStrikePatternEnum;

  @Input()
  analysis: TwoDimensionalAiAssessmentViewModelRead;
  section: string;


  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.initialized = true;
  }

  getTextDescription()
  {
    if (this.section.toLowerCase() == "general")
      return "General Form metrics influence how efficiently you move and how much stress your joints and muscles experience with each step.";
    else if (this.section.toLowerCase() == "pelvis")
      return "Pelvic metrics reveal how well your hips stabilize and support your stride, influencing balance, efficiency, and overall running posture.";
    else if (this.section.toLowerCase() == "hips")
      return "Hip metrics show how your legs move and align during each stride, affecting stability, stride length, and the efficiency of your forward motion.";
    else if (this.section.toLowerCase() == "knees")
      return "Knee metrics highlight how your legs absorb impact and generate power with each step, influencing running efficiency, shock absorption, and overall joint health.";
    else if (this.section.toLowerCase() == "ankles")
      return "Ankle metrics reflect how your feet interact with the ground, affecting balance, stability, and how efficiently force is transferred through each stride."

    return "";
  }

  removeNegtiveSign(value: number): number
  {
    return Math.abs(value);
  }

  getLabelPelvicDrop(value: number, isLeft: boolean)
  {
    if (value < 0) {
      return isLeft ? 'lft up' : 'rgt up'
    }
    else {
      return isLeft ? 'lft down' : 'rgt down'
    }
  }

  getLabelForwardLean(value: number)
  {
    if (value < 0) {
      return 'ext'
    }
    else {
      return 'flex';
    }
  }

  getLabelHipAdduction(value: number)
  {
    if (value < 0) {
      return 'add'
    }
    else {
      return 'abd';
    }
  }

  getLabelTibialInclination(value: number)
  {
    if (value < 0) {
      return 'ext'
    }
    else {
      return 'flex';
    }
  }

  getLabelAnklePronatoin(value: number)
  {
    if (value < 0) {
      return 'sup'
    }
    else {
      return 'pron';
    }
  }

  getLabeCrossover(value: number)
  {
    if (value < 0) {
      return 'add'
    }
    else {
      return 'abd';
    }
  }

  getLabelFootInclination(value: number)
  {
    if (value < 0) {
      return 'DF'
    }
    else {
      return 'PL';
    }
  }

  overrideScore(scoreLevel: string)
  {
    if (scoreLevel == 'G')
      return "E";
    else if (scoreLevel == 'GF')
      return "G";

    return scoreLevel;
  }
}
